// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"9425d8d3","48":"7f277598","210":"12decc0a","219":"2bda2345","248":"2187be65","271":"9d60efcf","296":"79caee68","350":"58118b34","533":"f71eafee","730":"a80281f5","923":"cd263e3c"}[chunkId] + ".chunk.js";
};